const ratingValues = [
  {
    value: '1',
    text: '1'
  },
  {
    value: '2',
    text: '2'
  },
  {
    value: '3',
    text: '3'
  },
  {
    value: '4',
    text: '4'
  },
  {
    value: '5',
    text: '5'
  },
  {
    value: '6',
    text: '6'
  },
  {
    value: '7',
    text: '7'
  }
];

const questionHeader = {
  type: 'html',
  name: 'HTML_QUESTION_Header',
  html: `
  <div class="">
    <span style="font-size:16px;">
      Por favor indica en qué medida estas afirmaciones te representan utilizando la siguiente escala:
    </span>
    <br />
    <br />
  </div>
  `
};

export const TestIntro = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  // showProgressBar: 'top',
  // progressBarType: 'questions',
  goNextPageAutomatic: false,
  firstPageIsStarted: false,
  showPrevButton: false,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  showQuestionNumbers: 'off',
  requiredText: `*`,
  pages: [
    {
      name: 'IG_PAGE_01_M',
      title: '',
      elements: [
        {
          type: 'html',
          name: 'HTML_DIALOG_01_IGM',
          html: `
  <div class="QuestionText BorderColor">
    <span style="font-size:16px;">
      <span style="font-family:arial,helvetica,sans-serif;">
        <h3>Instrucciones</h3>
      </span>
      <br />
      Para finalizar, a continuación encontrarás una lista de afirmaciones relacionadas con el tomar decisiones en general.
      <br />
      <br />
      Por favor indica en qué medida estas afirmaciones te representan usando una escala de <strong>1</strong> (No me representa para nada) a <strong>7</strong> (Me representa muy bien), tal como se presenta a continuación:
      <br />
      <br />
      <div class="qstn-likert-label top">
        <div>No me representa para nada</div>
      </div>
      <div class="btn-group">
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="IG_00" aria-required="true" aria-label="1" value="1"><span class="quanta_q_rating_item_text"><span>1</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="IG_00" aria-required="true" aria-label="2" value="2"><span class="quanta_q_rating_item_text"><span>2</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="IG_00" aria-required="true" aria-label="3" value="3"><span class="quanta_q_rating_item_text"><span>3</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="IG_00" aria-required="true" aria-label="4" value="4"><span class="quanta_q_rating_item_text"><span>4</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="IG_00" aria-required="true" aria-label="5" value="5"><span class="quanta_q_rating_item_text"><span>5</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="IG_00" aria-required="true" aria-label="6" value="6"><span class="quanta_q_rating_item_text"><span>6</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="IG_00" aria-required="true" aria-label="7" value="7"><span class="quanta_q_rating_item_text"><span>7</span></span></label>
      </div>
      <div class="qstn-likert-label bottom">
        <div>Me representa muy bien</div>
      </div>
    </span>
  </div>
`
        }
      ]
    }
  ]
};

const ITEMS = [
  { value: 'IG_02', text: 'Me caracterizaría como una persona indecisa' },
  { value: 'IG_03', text: 'No sé como tomar decisiones' },
  { value: 'IG_06', text: 'Puedo tomar decisiones rápidamente' },
  { value: 'IG_08', text: 'Trato de evitar tomar decisiones' },
  {
    value: 'IG_09',
    text: 'Intento dejar la toma de decisiones a otras personas'
  },
  {
    value: 'IG_12',
    text:
      'Normalmente después de que tomo una decisión, creo que me he equivocado'
  },
  { value: 'IG_13', text: 'Es difícil para mi tomar una decisión' },
  {
    value: 'IG_14',
    text: 'Sé que pasos debo realizar para tomar una decisión'
  },
  {
    value: 'IG_15',
    text: 'Cuando tomo una decisión, normalmente me siento seguro'
  },
  { value: 'IG_17', text: 'Generalmente me demoro en tomar una decisión' },
  {
    value: 'IG_19',
    text:
      'Prefiero tomar las decisiones por mi mismo que dejárselo a otras personas'
  },
  {
    value: 'IG_21',
    text: 'Una vez que tomo una decisión, dejo de preocuparme por el asunto'
  }
];

const baseInfo = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  showProgressBar: 'top',
  progressBarType: 'pages',
  goNextPageAutomatic: true,
  firstPageIsStarted: false,
  showPrevButton: true,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  // showQuestionNumbers: 'off',
  requiredText: ``,
  pages: ITEMS.map((item, index) => {
    return {
      name: item.value,
      title: '',
      elements: [
        questionHeader,
        {
          type: 'rating',
          name: item.value,
          title: item.text,
          isRequired: true,
          minRateDescription: 'No me representa para nada',
          maxRateDescription: 'Me representa muy bien',
          rateValues: ratingValues
        }
      ]
    };
  })
};

export default baseInfo;
